//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { useSyncExternalStore } from 'react';

import { SessionMode } from '@moderation-mode/constants/SessionMode';
import { sessionModeStore } from '@moderation-mode/sessionModeStore';

interface ModeratorSurface {
  isModeratorSurface: boolean;
}

export const useModeratorSurface = (): ModeratorSurface => {
  const mode = useSyncExternalStore(
    sessionModeStore.subscribe,
    sessionModeStore.getMode,
  );

  return { isModeratorSurface: mode === SessionMode.Moderator };
};
